module.exports = __webpack_public_path__ + "static/media/VISA-PCI-300x149.c94b1cf8.jpg";